<template>
  <a-row id="globalHeader" align="center" :wrap="false">
    <a-col flex="auto">
      <!--事件触发+高亮追踪-->
      <a-menu
        mode="horizontal"
        @menu-item-click="doMenuClick"
        :selected-keys="selectKeys"
      >
        <a-menu-item
          key="0"
          :style="{ padding: 0, marginRight: '38px' }"
          disabled
        >
          <div class="title-bar">
            <img class="logo" src="../assets/AppLogo.png" alt="app logo" />
            <div class="title">智答答</div>
          </div>
        </a-menu-item>
        <!--根据路由配置动态生成菜单项-->
        <a-menu-item v-for="item in visibleRoutes" :key="item.path">{{
          item.name
        }}</a-menu-item>
      </a-menu>
    </a-col>
    <a-col flex="100px">
      <template v-if="loginUserStore.loginUser.id">
        <!-- 使用下拉菜单包裹退出按钮 -->
        <a-dropdown @select="handleDropdownClick">
          <a-space style="cursor: pointer">
            <a-avatar
              :size="24"
              :style="{ marginRight: '8px' }"
              :image-url="loginUserStore.loginUser.userAvatar"
            >
            </a-avatar>
            <a-typography-text>
              {{ loginUserStore.loginUser.userName ?? "匿名" }}
            </a-typography-text>
          </a-space>

          <template #content>
            <a-doption value="logout">
              <template #icon><icon-export /></template>
              退出登录
            </a-doption>
          </template>
        </a-dropdown>
      </template>
      <div v-else>
        <a-button type="primary" @click="doLogin">登录</a-button>
      </div>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { routes } from "../router/routes";
import { computed, ref } from "vue";
import { useLoginUserStore } from "@/store/useStore";
import checkAccess from "@/access/checkAccess";
import { userLogoutUsingPost } from "@/api/userController";
import removeToken from "@/utils/auth";

const loginUserStore = useLoginUserStore();
const router = useRouter();

const selectKeys = ref(["/"]);

router.afterEach((to, from, failure) => {
  selectKeys.value = [to.path];
});

//跳转事件
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};

const doLogin = () => {
  router.push({
    path: "/user/login",
  });
};

// 下拉菜单触发
const handleDropdownClick = (value: string) => {
  if (value === "logout") {
    doLogout();
  }
};

const doLogout = async () => {
  try {
    // 第一步：调用后端接口，此时 localStorage 中的 Token 还存在，请求头能带上 Token
    const res = await userLogoutUsingPost();

    if (res.data?.code === 0) {
      // 第二步：只有后端返回成功，才清理本地 Token 和用户信息
      // 假设你的 store 有 logout 方法，或者手动重置
      loginUserStore.reset(); // 或者 yourStore.logout()

      // 第三步：清理 Token
      removeToken();

      router.push({
        path: "/user/login",
        // 可以带上 redirect 参数，回来时自动跳转到之前的页面
        query: { redirect: router.currentRoute.value.fullPath },
      });
    } else {
      console.error("退出登录接口调用失败:", res.data);
      // 这里处理接口失败的情况（例如：token 已过期，此时可以强制清理）
      // 强制清理本地状态并跳转
      loginUserStore.reset();
      removeToken();
      router.push("/user/login");
    }
  } catch (e) {
    // 如果请求本身发送失败（如网络错误），也尝试清理本地状态
    loginUserStore.reset();
    removeToken();
    router.push("/user/login");
  }
};

//显隐条件
const visibleRoutes = computed(() => {
  return routes.filter((item) => {
    if (item.meta?.hideInMenu) {
      return false;
    }
    //根据权限过滤菜单
    if (!checkAccess(loginUserStore.loginUser, item.meta?.access as string)) {
      return false;
    }
    return true;
  });
});
</script>

<style scoped>
#GboalHeader {
  margin-bottom: 16px;
}

.title-bar {
  display: flex;
  align-items: center;
}
.logo {
  height: 48px;
}
.title {
  color: black;
  margin-left: 16px;
}
</style>
